<ion-app [style]="enableMenu ? 'background-color: ' + backgroundColor : ''">
  @if (fullScreenLoadingService.isLoading()) {
    <div class="create-account-loading-overlay">
      <img src="assets/img/bowtie-white.svg" alt="TIDY" class="create-account-loading-bow" />
    </div>
  }

  @if (demoAccountService.entrancePhase() === 'cover' || demoAccountService.entrancePhase() === 'reveal') {
    <div
      class="demo-entrance-sweep"
      [class.revealing]="demoAccountService.entrancePhase() === 'reveal'">
      <div class="demo-sweep-gradient"></div>
      <div class="demo-sweep-sheen"></div>
      <div class="demo-sweep-sparkles">
        <span></span><span></span><span></span><span></span>
        <span></span><span></span><span></span><span></span>
      </div>
      <div class="demo-sweep-content">
        <div class="demo-sweep-logo-ring">
          <img src="assets/img/bowtie-white.svg" alt="TIDY" class="demo-sweep-logo" />
        </div>
        <div class="demo-sweep-title">
          <tidy-text [title]="'Preparing Demo'" />
        </div>
        <div class="demo-sweep-dots">
          <span></span><span></span><span></span>
        </div>
      </div>
    </div>
  }

  <!-- The blur backdrop also renders during 'reveal', underneath the sweep, so
       the wipe uncovers an already-blurred app instead of flashing the bare
       page before the welcome card lands -->
  @if (demoAccountService.entrancePhase() === 'reveal' || demoAccountService.entrancePhase() === 'welcome') {
    <div
      class="demo-welcome-backdrop"
      [class.leaving]="demoWelcomeLeaving"
      (click)="dismissDemoWelcome()">
      @if (demoAccountService.entrancePhase() === 'welcome') {
      <div class="demo-welcome-card" (click)="$event.stopPropagation()">
        <div class="demo-welcome-icon">
          <span class="material-icons">auto_awesome</span>
        </div>
        <div class="demo-welcome-title">
          <tidy-text [largeTitle]="'Welcome to TIDY!'" />
        </div>
        <div class="demo-welcome-body">
          <tidy-text [body]="'Take a look around and let us know when you\'re ready to get started.'" />
        </div>
        <div class="demo-welcome-actions">
          <tidy-button
            [text]="'View Demo Account'"
            [action]="dismissDemoWelcome"
            class="primary" />
        </div>
      </div>
      }
    </div>
  }

  <!-- Guided demo tour: walks the visitor through the five demo landing pages -->
  <demo-tour-overlay />

  <!-- Halloween week only (Oct 28-31): spooky intro, pumpkin hunt and other easter eggs -->
  <tidy-halloween />

  <tidy-translations [translations]="translations" />

  @if (appliedGiftCode) {
    <div class="gift-code-banner">
      <span>"{{ appliedGiftCode.code.toUpperCase() }}" code applied</span>
      <button class="gift-code-banner-dismiss" (click)="dismissGiftCode()">×</button>
    </div>
  }

  <!-- Demo session pill: nudge to create a real account (yields to the tour dock) -->
  @if (showDemoFloatingPill && isDesktopView && !showLivePill && !isDemoTourActive) {
    <div class="demo-float-anchor">
      <div class="demo-pill dp-v4">
        <span class="dp-sparkle material-icons">auto_awesome</span>
        <span class="dp-label">Viewing Demo Account</span>
        <span class="dp-divider"></span>
        @if (demoIndicatorShowCallIcon) {
          <span class="cp-call material-icons">call</span>
        }
        <span class="dp-text">{{ demoIndicatorSubtext }}</span>
        <button class="dp-btn dp-btn-white" (click)="openGetStartedFlow()">{{ demoIndicatorLabel }}</button>
      </div>
    </div>
  }

  <!-- Post-conversion pill: routes to schedule the setup call until it's booked, then to
       the TIDY AI Property Manager page. -->
  @if (showLivePill && isDesktopView && !isDemoSession) {
    <div class="demo-float-anchor">
      <button
        class="demo-pill live5 lv-light lv-onebtn"
        [class.lv-attention]="livePillAttention"
        (click)="openLivePill()">
        <span class="lc-block">
          <img [src]="managerPhoto" class="lc-avatar" alt="Account Manager" />
          <span class="lc-text">
            <span class="lc-eyebrow">Account Manager</span>
            <span class="lc-name">{{ managerName }}</span>
          </span>
        </span>
        <span class="dp-divider"></span>
        @if (!callScheduled && !setupCallCompleted) {
          <span class="cp-dot-amber"></span>
          <span class="dp-text">Schedule Setup Call</span>
        } @else {
          <span class="cp-mini-ring"></span>
          <span class="dp-text"><strong>{{ livePropertiesCount }} of {{ livePropertiesTotal }}</strong>&nbsp;properties live</span>
          @if (!setupCallCompleted) {
            <span class="dp-divider"></span>
            <span class="cp-call material-icons">call</span>
            <span class="dp-text">Call scheduled</span>
          }
          @if (actionItemsCount > 0) {
            <span class="dp-divider"></span>
            <span class="cp-dot-amber"></span>
            <span class="dp-text">{{ actionItemsCount }} action items</span>
          }
        }
        @if (targetGoLiveDateDisplay) {
          <span class="dp-divider"></span>
          <span class="cp-target material-icons">gps_fixed</span>
          <span class="dp-text">Go Live Date: <strong>{{ targetGoLiveDateDisplay }}</strong></span>
        }
        <span class="cp-chevron material-icons">chevron_right</span>
      </button>
    </div>
  }

  <!-- Optimizer "Unsaved changes" bar — rendered here (app root, sibling of the
       account-manager pill) so it centers on the whole viewport and sits just
       above the pill, instead of being trapped inside the offset .ion-page.
       Driven by the Optimizer or the listing builder via OptimizerSaveBarService. -->
  @if (optimizerSaveBar.visible()) {
    <div class="bs-save-anchor" [class.bs-save-anchor--mobile]="!isDesktopView" [class.bs-save-anchor--over-panel]="optimizerSaveBar.overPanel()">
      <div class="bs-save-bar" role="region" aria-label="Unsaved changes">
        <span class="bs-save-bar__label">
          <span class="bs-save-bar__dot" aria-hidden="true"></span>
          <span class="bs-save-bar__label-text">{{ 'Unsaved changes' | translate }}</span>
        </span>
        <div class="bs-save-bar__actions">
          <button
            type="button"
            class="bs-save-bar__btn bs-save-bar__btn--discard"
            [disabled]="optimizerSaveBar.saving()"
            (click)="optimizerSaveBar.discard()">{{ 'Remove Changes' | translate }}</button>
          <button
            type="button"
            class="bs-save-bar__btn bs-save-bar__btn--save"
            [disabled]="optimizerSaveBar.saving()"
            (click)="optimizerSaveBar.save()">{{ (optimizerSaveBar.saving() ? 'Saving...' : 'Save Changes') | translate }}</button>
        </div>
      </div>
    </div>
  }

  @if (isDesktopView) {
    <div class="desktop-nav-container">
      <ion-split-pane
        when="(min-width: 711px)"
        contentId="main"
        [class.split-pane]="width > breakLargeResolution && enableMenu">
        <ion-menu
          [hidden]="menuType !== 'desktop' || !enableMenu"
          id="loggedInMenu"
          contentId="main"
          [content]="content"
          persistent="true"
          side="start"
          [class.show-secondary-menu]="enableMenu && mainMenu.showSecondaryMenu"
          [class.menu-collapsed]="isNavCollapsed">
          @if (menuType === 'desktop' && enableMenu) {
            <app-desktop-nav />
          }
        </ion-menu>
        <div id="main" #content>
          <router-outlet
            [class.menuDisabled]="false"
            [class.hideNavBar]="width  > breakLargeResolution  && !pagesToShowHeader"
            [class.showNavBar]="width  < breakLargeResolution"
            [class.desktop-content-margin]="width > breakLargeResolution" />
        </div>
      </ion-split-pane>



    </div>
  }

  @if (isMobileView) {
    <router-outlet
      [class.menuDisabled]="false"
      [class.hideNavBar]="width  > breakLargeResolution  && !pagesToShowHeader"
      [class.showNavBar]="width  < breakLargeResolution"
      [class.desktop-content-margin]="width > breakLargeResolution"
      animated="false"
      id="main"
      #content
      swipeBackEnabled="false" />
  }

  <div id="tidy-loading-modal" style="display: none">
    <div class="loading-container">
      <div
        class="loading-wrapper sc-ion-loading-ios custom-loading-box"
        role="dialog">
        <div class="loading-spinner sc-ion-loading-ios">
          <ion-spinner
          class="sc-ion-loading-ios spinner-lines hydrated" />
        </div>
        <div class="loading-content sc-ion-loading-ios custom-loading-text">
          Loading...
        </div>
      </div>
    </div>
  </div>

  @if ({ value: rightSidePanelService.isOpen$ | async }; as isOpen) {
    @if (isOpen.value) {
      <app-right-side-dialog-content
      />
    }
  }

  @if (showSearchOverlay) {
    <div class="global-search-overlay" (click)="closeSearchOverlay($event)">
      <div class="global-search-container" (click)="$event.stopPropagation()">
        <div class="global-search-input-wrapper">
          <img src="assets/img/search-header.svg" class="global-search-icon" />
          <input
            #globalSearchInput
            type="text"
            class="global-search-input"
            placeholder="Search pages, properties, pros..."
            [formControl]="searchControl"
            (keydown)="handleSearchKeydown($event)"
            (keydown.escape)="closeSearchOverlay($event)" />
          @if (searchControl.value) {
            <img
              src="assets/svg/close-outline.svg"
              class="global-search-clear"
              (click)="clearSearch()" />
          }
        </div>
        @if (searchControl.value && filteredSearchItems && filteredSearchItems.length > 0) {
          <div class="global-search-results">
            @for (section of filteredSearchItems; track section.list) {
              <div class="global-search-section">
                <div class="global-search-section-header">{{section.list}}</div>
                @for (item of section.items; track item.title) {
                  <div class="global-search-item" [class.selected]="item === selectedSearchItem" (click)="handleSearchItemClick(item)">
                    <img [src]="item.image" class="global-search-item-icon" />
                    <span class="global-search-item-title">{{item.title | translate}}</span>
                  </div>
                }
              </div>
            }
          </div>
        }
        @if (searchControl.value && (!filteredSearchItems || filteredSearchItems.length === 0)) {
          <div class="global-search-results">
            <div class="global-search-no-results">No results found</div>
          </div>
        }
      </div>
    </div>
  }

  <app-preview-ribbon />

  <!-- load ion-modal entry script -->
  <ion-modal class="hide" />
</ion-app>
